import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

function MainLayout({ children, onApplyClick }) {
  return (
    <div className="relative flex h-screen flex-col overflow-hidden bg-[#FFF9F1] text-slate-900">
      <Header onApplyClick={onApplyClick} />
      {children}
      <Footer />
    </div>
  );
}

export default MainLayout;
